import { render, staticRenderFns } from "./readyUploadSource.vue?vue&type=template&id=36e17ef7&scoped=true&"
import script from "./readyUploadSource.vue?vue&type=script&lang=js&"
export * from "./readyUploadSource.vue?vue&type=script&lang=js&"
import style0 from "./readyUploadSource.vue?vue&type=style&index=0&id=36e17ef7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e17ef7",
  null
  
)

export default component.exports